import {
  readPlace,
  editPlace,
  createPlace,
  archivePlace,
} from "~/shared/placeAbilities"

export const usePlacePermissions = async () => {
  const canReadPlace = await allows(readPlace)
  const canEditPlace = await allows(editPlace)
  const canCreatePlace = await allows(createPlace)
  const canArchivePlace = await allows(archivePlace)

  return { canReadPlace, canEditPlace, canCreatePlace, canArchivePlace }
}
